import React from "react";

export default function Projects() {
  return (
    <>
      <div className="div"></div>
      <div className="div-2">Project Partners</div>
      <div className="div-3">
        <div className="builder-columns div-4">
          <div className="builder-column column">
            <div className="div-5">
              <a href="https://www.movinc.sg/">
                <picture>
                  <source
                    srcset="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?format=webp&width=100 100w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?format=webp&width=200 200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?format=webp&width=400 400w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?format=webp&width=800 800w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?format=webp&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?format=webp&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?format=webp&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    alt="image1"
                    src="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a"
                    srcset="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?width=100 100w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?width=200 200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?width=400 400w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?width=800 800w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?width=1200 1200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?width=1600 1600w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a?width=2000 2000w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F2487fc8bb78e4f60b89243a05aa2086a"
                    className="image"
                  ></img>
                </picture>
              </a>
              <div className="builder-image-sizer image-sizer" />
            </div>
          </div>
          <div className="builder-column column-2">
            <div className="div-6">
              <a href="https://enatechhub.com/">
                <picture>
                  <source
                    srcset="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?format=webp&width=100 100w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?format=webp&width=200 200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?format=webp&width=400 400w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?format=webp&width=800 800w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?format=webp&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?format=webp&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?format=webp&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    alt="image2"
                    src="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c"
                    srcset="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?width=100 100w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?width=200 200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?width=400 400w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?width=800 800w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?width=1200 1200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?width=1600 1600w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c?width=2000 2000w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F9ff2e7624a1f44a2b2602861ef7b756c"
                    className="image"
                  />
                </picture>
              </a>
              <div className="builder-image-sizer image-sizer-2" />
            </div>
          </div>
          <div className="builder-column column-3">
            <div className="div-7">
              <a href="https://enablingvillage.sg/assistive-technologies-at-the-enabling-village/">
                <picture>
                  <source
                    srcset="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?format=webp&width=100 100w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?format=webp&width=200 200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?format=webp&width=400 400w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?format=webp&width=800 800w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?format=webp&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?format=webp&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?format=webp&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df"
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    alt="image3"
                    src="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df"
                    srcset="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?width=100 100w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?width=200 200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?width=400 400w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?width=800 800w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?width=1200 1200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?width=1600 1600w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df?width=2000 2000w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2F3ab27216a3c04c43a70144ed9bf556df"
                    className="image"
                  />
                </picture>
              </a>
              <div className="builder-image-sizer image-sizer-3" />
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .div {
          display: flex;
          flex-direction: column;
          position: relative;
          margin-top: 20px;
          line-height: normal;
          height: auto;
        }
        .div-2 {
          display: flex;
          flex-direction: row;
          max-width: 582px;
          justify-content: flex-start;
          align-items: flex-start;
          padding-top: 129px;
          padding-right: 44px;
          padding-bottom: 18px;
          padding-left: 0px;
          background-color: rgba(255, 255, 255, 1);
          color: rgba(0, 0, 0, 1);
          font-size: 80px;
          letter-spacing: -3%;
          text-align: left;
          font-family: "Open Sans", sans-serif;
          margin-left: -1px;
          text-decoration: underline;
        }
        .div-3 {
          display: flex;
          flex-direction: column;
          position: relative;
          margin-top: 20px;
        }
        .div-4 {
          display: flex;
        }
        @media (max-width: 999px) {
          .div-4 {
            flex-direction: column;
            align-items: stretch;
          }
        }
        .column {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(33.333333333333336% - 13.333333333333334px);
          margin-left: 0px;
        }
        @media (max-width: 999px) {
          .column {
            width: 100%;
          }
        }
        .div-5 {
          display: flex;
          position: relative;
          min-width: 20px;
          min-height: 20px;
          max-width: 315px;
        }
        .image {
          object-fit: contain;
          object-position: center;
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
        }
        .image-sizer {
          width: 100%;
          padding-top: 154.22%;
          pointer-events: none;
          font-size: 0;
        }
        .column-2 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(33.333333333333336% - 13.333333333333334px);
          margin-left: 20px;
        }
        @media (max-width: 999px) {
          .column-2 {
            width: 100%;
          }
        }
        .div-6 {
          display: flex;
          position: relative;
          min-width: 20px;
          min-height: 20px;
          max-width: 308px;
        }
        .image-sizer-2 {
          width: 100%;
          padding-top: 154.34%;
          pointer-events: none;
          font-size: 0;
        }
        .column-3 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: calc(33.333333333333336% - 13.333333333333334px);
          margin-left: 20px;
        }
        @media (max-width: 999px) {
          .column-3 {
            width: 100%;
          }
        }
        .div-7 {
          display: flex;
          position: relative;
          min-width: 20px;
          min-height: 20px;
          max-width: 320px;
        }
        .image-sizer-3 {
          width: 100%;
          padding-top: 152.85%;
          pointer-events: none;
          font-size: 0;
        }
      `}</style>
    </>
  );
}
